module.exports = __webpack_public_path__ + "static/chanterelles-86d54cf65e98a718066ae8bf76038469.jpg";